import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from '../utilities/utilities.service';


@Injectable({
  providedIn: 'root'
})
export class CustomerfeedbackmanagementService {

  constructor(private http: HttpClient, private UTS: UtilitiesService,) { }
  getcustomerFeedbackManagementList() {
    return this.http
      .post(
        `${environment.ESHOP_URL}/customerFeedbackManagementList`, {}
      )
  }
  getCurrentDatetime() {
    const now = new Date();
    return now.getFullYear() + '-' +
      ('0' + (now.getMonth() + 1)).slice(-2) + '-' +
      ('0' + now.getDate()).slice(-2) + ' ' +
      ('0' + now.getHours()).slice(-2) + ':' +
      ('0' + now.getMinutes()).slice(-2) + ':' +
      ('0' + now.getSeconds()).slice(-2);
  }
  checkcustomerFeedback(data) {
    var CfmRequestType : any = localStorage.getItem('CfmRequestType');
    this.getcustomerFeedbackManagementList().subscribe((resp:any) => {
      try {
        if(resp && resp?.success){
          var transactionalSurvey: any = {}
          let nationality = '';
          if(this.UTS.getLocaleLanguage() == 'en'){
            nationality = resp && resp?.nationality ? resp?.nationality : ''
          } else{
            nationality = resp && resp?.nationalityAr ? resp?.nationalityAr : ''
          }
          transactionalSurvey.transactionId =resp && resp?.cfmToken ? resp?.cfmToken : '' // login
          transactionalSurvey.seSegment = resp && resp?.seSegment ? resp?.seSegment : ''  // login
          transactionalSurvey.nationality = nationality // login
          transactionalSurvey.partyId = resp && resp?.partyId ? resp?.partyId : ''// login
          transactionalSurvey.productDetail = ''
          transactionalSurvey.language = this.UTS.getLocaleLanguage() ? this.UTS.getLocaleLanguage().toUpperCase() : 'EN'
          transactionalSurvey.transactionDate = this.getCurrentDatetime() ? this.getCurrentDatetime() : '';
          transactionalSurvey.channel = 'B2CPortal'
          transactionalSurvey.requestType = CfmRequestType ? CfmRequestType : ''
          transactionalSurvey.Additional_info1 = data?.mainServiceAccountNo ? data?.mainServiceAccountNo : '';
          localStorage.setItem('transactionalSurvey', JSON.stringify(transactionalSurvey));
          var relationalSurvey: any = {}
          relationalSurvey.transaction = resp && resp?.cfmToken ? resp?.cfmToken : '' // login
          relationalSurvey.language = this.UTS.getLocaleLanguage() ? this.UTS.getLocaleLanguage().toUpperCase() : 'EN'
          relationalSurvey.channel = 'B2CPortal'
          relationalSurvey.requestType = CfmRequestType ? CfmRequestType : ''
          localStorage.setItem('relationalSurvey', JSON.stringify(relationalSurvey));
        } else{
          this.userNotLogin();
        }
      } catch (error) {
        console.log(error)
        this.userNotLogin();
      }
    }, error => {
      console.log(error)
      this.userNotLogin();
    })
  }
  userNotLogin() {
    try {
      var CfmRequestType : any = localStorage.getItem('CfmRequestType');
      localStorage.removeItem('relationalSurvey')
      localStorage.removeItem('transactionalSurvey');
      var transactionalSurvey: any = {}
      transactionalSurvey.productDetail = ''
      transactionalSurvey.language = this.UTS.getLocaleLanguage() ? this.UTS.getLocaleLanguage().toUpperCase() : 'EN'
      transactionalSurvey.transactionDate = this.getCurrentDatetime() ? this.getCurrentDatetime() : '';
      transactionalSurvey.channel = 'B2CPortal'
      transactionalSurvey.requestType = CfmRequestType ? CfmRequestType : ''
      localStorage.setItem('transactionalSurvey', JSON.stringify(transactionalSurvey))
    } catch (error) {
      console.log(error)
    }
  }
  SetDataintransactionalSurvey(sku){
    try {
      var CfmRequestType : any = localStorage.getItem('CfmRequestType');
      var transactionalSurvey:any = JSON.parse(localStorage.getItem('transactionalSurvey'))
      if(transactionalSurvey){
        transactionalSurvey.productDetail =sku && sku?.displayName ? sku?.displayName : ''
        transactionalSurvey.requestType =CfmRequestType ? CfmRequestType : '' 
        localStorage.setItem('transactionalSurvey', JSON.stringify(transactionalSurvey));
      } 
    } catch (error) {
      console.log(error)
    } 
  }
}
